import classNames from 'classnames';
import type { InteractiveAtomSize } from '../utils/InteractiveAtomProps';
import { paddingMinusBorder } from '../utils/tailwind/paddingMinusBorder';

const baseClassName =
  'border border-default bg-default overflow-auto rounded-lg focus:outline-none focus:border-status-selected';

const sizeClassName: {
  [key in InteractiveAtomSize]: string;
} = {
  large: 'text-base',
  default: 'text-sm',
  small: 'text-xs',
};

const textAreaInputWrapperStateClassName = {
  disabled: 'bg-status-disabled text-status-disabled-dark',
  error: 'border-status-error',
  autogrow: 'h-full resize-none overflow-hidden',
  autogrowBySize: {
    large: paddingMinusBorder.xs,
    default: paddingMinusBorder['2xs'],
    small: paddingMinusBorder['2xs'],
  },
};

export const getTextAreaInputClassNames = (
  size: InteractiveAtomSize = 'default',
  isDisabled = false,
  hasError = false,
  isAutogrow = false,
  className?: string,
): string =>
  classNames(
    className,
    'textarea-input',
    'subtract-border',
    baseClassName,
    sizeClassName[size],
    isAutogrow
      ? [
          textAreaInputWrapperStateClassName.autogrow,
          textAreaInputWrapperStateClassName.autogrowBySize[size],
        ]
      : paddingMinusBorder.xs,
    isDisabled && textAreaInputWrapperStateClassName.disabled,
    hasError && textAreaInputWrapperStateClassName.error,
  );
